import { Middleware } from '@reduxjs/toolkit';
import { setForeignState } from '@/services/ipLocationSlice';

const hasRTKQMeta = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  action: any,
): action is {
  meta: {
    baseQueryMeta: {
      request: Request;
      response?: Response;
    };
  };
} => action?.meta?.baseQueryMeta?.request instanceof Request;

export const ipLocationMiddleware: Middleware = (api) => (next) => (action) => {
  if (hasRTKQMeta(action)) {
    const response: Response | undefined = action?.meta?.baseQueryMeta?.response;
    if (response?.status != 200) {
      return next(action);
    }
    const headers: Headers | undefined = response?.headers;
    const foreignState: string | null = headers?.get('X-Foreign-State');
    if (foreignState !== null) {
      api.dispatch(setForeignState(foreignState));
    }
  }
  return next(action);
};
